// extracted by mini-css-extract-plugin
module.exports = {"youtube":"EditorVideoDialog_youtube__AVoYw"};